import * as React from 'react'

import { Loader } from '@espoon-voltti/react-components/components'

import { Store, useStore } from '../services/use-store'

export const StoreLoader: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const store = useStore()
  return store.loading ? (
    <Loader />
  ) : (
    <Store.Provider value={store}>{children}</Store.Provider>
  )
}
